/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import Typography from "@mui/material/Typography";
import RecordRenderer from "../RecordRenderer";

function StaticView(props) {
  const { gridItem } = props;
  // get main form values
  const gridRecords = useSelector((state) => state.formProps[gridItem.key]);

  return (
    <>
      <RecordRenderer {...props} records={gridRecords} />
      {(!gridRecords || gridRecords.length === 0) && (
        <Typography align="center" sx={{ marginTop: "2rem" }}>
          No information provided.
        </Typography>
      )}
    </>
  );
}
export default StaticView;
StaticView.propTypes = {
  gridItem: PropTypes.shape({
    key: PropTypes.string.isRequired,
  }).isRequired,
};
